export default String.raw`
$(document).ready(function() {
    header.init();
});

let menuBtnsWidths = [];
let stickyHeaderTimeoutId = null;
let isStickyHeader = false;
let isStickyHeaderNav = false;
let lastScrollTop = 0;
let mainDivPaddingTop = 0;
let headerHeight = 0;

const header = {
    init: function() {
        this.events();

        // QUICK SEARCH implementation
        function QuickSearch(searchFormSelector, filtersParam) {
            this.searchForm = document.getElementsByClassName(searchFormSelector)[0];
            this.filtersParam = filtersParam || 'ftrLst';
            this.search = async function () {
                const input = this.searchForm.querySelector('[name="search"]');
                const val = input.value;
                if (val != '' && val.length > 1) {
                    const data = js.getFormInputs(this.searchForm);
                    const res = await js.post(data);
                    window.app.newUrl(res.action.Redirect302);
                }
            }
        }

        // QUICK SEARCH binding
        window.quickSearch = new QuickSearch('quick-search-form-js', 'ftrLst');
	},

    changeLanguageOrCurrency: function(e, name) {
		const form = $(e.currentTarget).parents('.form-js');
		if($(e.currentTarget).index() == 0){
			form.addClass('hidden-js');
		} else {
			const val = $(e.currentTarget).data('val');
			form.find('[name="'+name+'"]').val(val);
			if(name == 'currency'){
				app.post(e, app.reload);
			} else {
				app.post(e);
			}
		}
	},

    autocomplete: function(e) {
        const phrase = e.target.value.replace(/[*]*/gi, '');
        const maxAutocompleteProducts = e.target.dataset.maxAutocompleteProducts;
        if (phrase != '' && phrase.length > 1) {
            $.get(location.pathname, { __action: 'Get/SearchAutocomplete', search: phrase }).then(function (res) {
                $('.header-autocomplete-closer-js').addClass('hidden-js');
                const loader = '<img class="loader-for-autocomplete-js" src="css/img/alo.gif" style="width:32px; height:32px; position:absolute; top: 50%; transform: translateY(-50%); right: 50px;">';
                $('.quick-search-form-js.autocomplete-form-js').append(loader);
                const url = res.action.Redirect302;
                $.get(url, {__collection:'products.Products|page.BaseHref|currencyExt.Symbol|config.Products.ShowCode'}, function(response) {
                    $('.autocomplete-js').remove();
                    const list = response.collection['products.Products'];
                    const showCode = response.collection['config.Products.ShowCode'];
                    if (list.length > 0){
                        let size = list.length;
                        if (list.length > maxAutocompleteProducts) {
                            size = maxAutocompleteProducts;
                        }
                        const baseHref = response.collection['page.BaseHref'];
                        const currency = response.collection['currencyExt.Symbol'];
                        let autocompleteList = '<div class="header__dropdown header__dropdown-list no-padding header__autocomplete autocomplete-js">';
                        const regPhrase = '(' + phrase.split(' ').join('|') + ')';
                        const reg = new RegExp(regPhrase, 'gi');
                        for (let i = 0; i < size; i++) {
                            const nameNoQuotes = list[i].Name.replace(/"/g, '&quot;');
                            const name = list[i].Name.replace(reg, function(str) {return '<strong>'+str+'</strong>'});
                            let code = '';
                            if(showCode){
                                code = list[i].Code.replace(reg, function(str) {return '<strong>'+str+'</strong>'});
                            }
                            
                            let price = '';
                            if(list[i].Price){
                                price = list[i].Price.toPrice() + ' ' + currency;
                            }
                            let img = '';
                            if(list[i].ImageId != -1 && !list[i].Image.ExternalUrl){
                                img = '<img src="' + baseHref + 'img/' + list[i].ImageId + '/' + i + '.jpg" />';
                            } else if ( list[i].Image && list[i].Image.ExternalUrl){
                                img = '<img alt="" src="' +  list[i].Image.ExternalUrl +  '"/>'
                            }
                            const itemUrl = list[i].Url || '';
                            const itemHref = (itemUrl.indexOf('//') === 0 || itemUrl.indexOf('://') > -1) ? itemUrl : (baseHref || '') + itemUrl;
                            const product = '  <a href="' + itemHref + '" class="header__autocomplete-product">' +
                                                '<div class="header__autocomplete-product-img">' + img + '</div>' +
                                                '<div class="header__autocomplete-product-names">' +
                                                    '<div class="header__autocomplete-product-name" title="' + nameNoQuotes + '">' + name + '</div>' +
                                                    '<div class="header__autocomplete-product-code">' + code + '</div>' +
                                                '</div>' +
                                            '</a>';
                            autocompleteList += product;
                        }
                        autocompleteList += '</div>';
                        $('.quick-search-form-js.autocomplete-form-js').append(autocompleteList);
                        $('.header-autocomplete-closer-js').removeClass('hidden-js');
                    }
                    $('.loader-for-autocomplete-js').remove();
                });
            });
        } else {
            $('.autocomplete-js').remove();
            $('.loader-for-autocomplete-js').remove();
            $('.header-autocomplete-closer-js').addClass('hidden-js');
        }
    },

    showSidebar: function(selector) {
        const sidebar = $(selector);
        if (sidebar.length > 0) {
            const sidebarContent = sidebar.find('.header-sidebar-content-js');
            sidebar.removeClass('none');
            setTimeout(function() {
                sidebar.removeClass('hide');
            }, 100);
            setTimeout(function() {
                sidebarContent.removeClass('hide');
                document.body.classList.add('modal-opened');
            }, 300);
        }
    },

    hideSidebar: async function(e) {
        let sidebar = $(e.currentTarget);
        let clientAreaTemplate = null;
        if (!$(e.currentTarget).hasClass('header-sidebar-js')) {
            sidebar = $(e.currentTarget).parents('.header-sidebar-js');
        }
        if (sidebar.hasClass('header-inquiry-sidebar-js')) {
            let cartId = window.app.getCookie('lastCartId');
            if(cartId == ''){
                cartId = -1;
            }
            await Promise.resolve($.post('', {__csrf: __CSRF, __action: 'Cart/Change', id: cartId}))
                .then(async () => {
                    const res = await Promise.resolve($.get(null, {__template: 'partials/common/header/client-area.html'}));
                    if (res.template) {
                        clientAreaTemplate = res.template;
                    }
                });
        }
        const sidebarContent = sidebar.find('.header-sidebar-content-js');
        sidebarContent.addClass('hide');
        setTimeout(function() {
            sidebar.addClass('hide');
        }, 500);
        setTimeout(function() {
            sidebar.addClass('none');
            document.body.classList.remove('modal-opened');
            if (clientAreaTemplate) {
                $('.suspended-js').removeClass('suspended-js');
                $('.client-area-js').html(clientAreaTemplate);
                if ($(window).width() < 769) {
                     $('.header-more-js').focus();
                } else {
                    $('.header-inquiry-js').focus();
                }
            }
        }, 800);
        
        if ($('.lock-focus-pre-js').length === 0) {
            app.offLockFocus();
        } else {
            app.resetLockFocus((f) => header.hideSidebar(f));
        }
    },

    searchCategory: function(e) {
        const searchValue =  $(e.currentTarget).parent().find('[name=search-categories]').val().replace(/[*]*/gi, '').toLowerCase();
        let isFilterOn = false;
        $('.sliding-categories-js .header-categories-item-js').each(function() {
            if (!$(this).data('name').toLowerCase().includes(searchValue)) {
                isFilterOn = true;
                $(this).addClass('hidden-js');
            } else {
                $(this).removeClass('hidden-js');
            }
        });
        if (isFilterOn) {
            $(e.currentTarget).parent().find('.header-categories-search-closer-js').removeClass('hidden-js');
        } else {
            $(e.currentTarget).parent().find('.header-categories-search-closer-js').addClass('hidden-js');
        }
    },

    /**
     * Initializes properly element-ordered header categories navbar with responsive overflow handling
     * @param {boolean} init - Whether this is initial load
     * 
     * Behavior:
     * - Desktop (>= 1440px): Shows items that fit + overflow in dropdown
     * - Mobile & Tablet (< 1440px): All items visible in sidebar
     */
    headerMenuInit: function(init) {
        if (window.innerWidth > 1440 && !init) {
            $('.header-menu__contact').hide();
            $('.header-sidebar-js').trigger("click");
        }
        
        if ($('.header-nav-list-js').length <= 0) {
            return;
        }
        
        if (window.innerWidth < 1440) {
            if ($('.header-nav-list-js').parents('.header-nav-js').length > 0) {
                const menuElement = $('.header-nav-list-js');
                const allItems = [];
                
                menuElement.children(':not(.dots)').each(function(index) {
                    const $elem = $(this);
                    const orderValue = parseInt($elem.css('order')) || index;
                    allItems.push({
                        element: $elem,
                        order: orderValue
                    });
                });
                
                $('.header-menu-dropdown-js').children().each(function(index) {
                    const $elem = $(this);
                    const orderValue = parseInt($elem.css('order')) || (1000 + index);
                    allItems.push({
                        element: $elem,
                        order: orderValue
                    });
                });
                
                allItems.sort((a, b) => a.order - b.order);
                
                $('.header-menu-dropdown-js').empty();
                $('.header-nav-dots-btn-js').addClass('hidden-js');
                
                const dotsButton = menuElement.find('.dots').detach();
                
                menuElement.children(':not(.dots)').remove();
                
                allItems.forEach(item => {
                    item.element
                        .removeClass('header__dropdown-item')
                        .show()
                        .css('display', '');
                    menuElement.append(item.element);
                });
                
                menuElement.append(dotsButton);
                
                menuElement.remove();
                $('.header-menu-content-js').prepend(menuElement);
                
                if (init) {
                    menuElement.addClass('visible');
                }
            }
            
            $('.header-menu__contact').show();
            return;
        }
        
        $('.header-menu__contact').hide();
        
        if ($('.header-nav-list-js').parents('.header-menu-content-js').length > 0) {
            const menuElement = $('.header-nav-list-js');
            
            $('.header-menu-dropdown-js').empty();
            $('.header-nav-dots-btn-js').addClass('hidden-js');
            
            menuElement.remove();
            $('.header-nav-js').append(menuElement);
        }
        
        const dropdownItems = $('.header-menu-dropdown-js').children().toArray();
        dropdownItems.forEach(elem => {
            const $elem = $(elem);
            const detached = $elem.detach();
            const itemIndex = detached.data('index');
            
            detached.removeClass('header__dropdown-item');
            
            let inserted = false;
            $('.header-nav-list-js').children(':not(.dots)').each(function() {
                const currentIndex = $(this).data('index');
                if (currentIndex > itemIndex) {
                    $(this).before(detached);
                    inserted = true;
                    return false;
                }
            });
            
            if (!inserted) {
                $('.header-nav-list-js .dots').before(detached);
            }
        });
        
        $('.header-menu-dropdown-js').empty();
        
        const menuContainer = $('.header-nav-list-js');
        const availableWidth = menuContainer.width();
        const dotsWidth = 60;
        
        menuBtnsWidths = [];
        const allMenuItems = [];
        
        menuContainer.children(':not(.dots)').each(function(index) {
            const $elem = $(this);
            $elem.show();
            
            const itemWidth = $elem.outerWidth(true);
            const orderValue = parseInt($elem.css('order')) || index;
            
            allMenuItems.push({
                element: $elem,
                width: itemWidth,
                order: orderValue,
                index: index
            });
            
            menuBtnsWidths.push(itemWidth);
            $elem.data('index', index);
        });
        
        const sortedItems = [...allMenuItems].sort((a, b) => a.order - b.order);
        
        let usedWidth = 0;
        const itemsToShow = [];
        const itemsToDropdown = [];
        
        sortedItems.forEach(item => {
            if (usedWidth + item.width + dotsWidth <= availableWidth) {
                itemsToShow.push(item);
                usedWidth += item.width;
            } else {
                itemsToDropdown.push(item);
            }
        });
        
        if (itemsToDropdown.length > 0) {
            $('.header-nav-dots-btn-js').removeClass('hidden-js');
            
            itemsToDropdown.forEach(item => {
                const detached = item.element.detach();
                detached.removeClass().addClass('header__dropdown-item');
                $('.header-menu-dropdown-js').append(detached);
            });
        } else {
            $('.header-nav-dots-btn-js').addClass('hidden-js');
        }
        
        itemsToShow.forEach(item => {
            item.element.show();
        });
        
        if (init) {
            menuContainer.addClass('visible');
        }
    },

    headerClientAreaInit: function() {
        const menuToMoveElements = $('.client-area-js .header-wishlist-btn-js, .client-area-js .header-inquiry-btn-js');
        const dropdown = $('.client-area-js .header-more-dropdown-js');
        menuToMoveElements.each(function() {
            if (window.innerWidth < 768 && !$(this).parents('.header-more-dropdown-js').length > 0) {
                const itemToMove = $(this).clone(true);
                $(this).remove();
                itemToMove.css('display', 'block');
                itemToMove.find('a, button').attr('tabindex', '-1');
                dropdown.append(itemToMove);
            } else if(window.innerWidth > 767 && $(this).parents('.header-more-dropdown-js').length > 0) {
                const itemToMove = $(this).clone(true);
                itemToMove.find('a, button').removeAttr('tabindex');
                $(this).remove();
                $('.client-area-js').append(itemToMove);
            }
        });
        if (window.innerWidth < 768) {
            if ($('.header-search-input-js').attr('placeholder') != __translations.Search) {
                $('.header-search-input-js').attr('placeholder', __translations.Search + '...')
            }
            $('.header-search-input-js').removeClass('hide-mobile-placeholder');
        }
    },

    stickyHeaderResize: function() {
        if($('.header-js').hasClass('fixed')) {
            if (window.innerWidth < 768) {
                $('.header-top-bar-js').show(400);
                $('.main-js').css('padding-top', 0);
                $('.header-js').removeClass('fixed');
            } else if (window.innerWidth > 767) {
                $('.header-top-bar-js').hide(400);
                if (isStickyHeader) {
                    clearTimeout(stickyHeaderTimeoutId);
                }   
                stickyHeaderTimeoutId = setTimeout(() => {
                    header.stickyHeader($('.header-js').height());
                }, 100);
            }
        }
    },
    
    stickyHeader: function(headerTopOffset) {
        const scrollTopValue = $(window).scrollTop() - $('.header-js').outerHeight();
        if (scrollTopValue > headerTopOffset && !isStickyHeader) {
            mainDivPaddingTop = $('.main-js').css('padding-top');
            headerHeight = $('.header-js').outerHeight();
            $('.main-js').css('padding-top', headerHeight + 'px');
            $('.header-js').addClass('fixed');
            $('.header-top-bar-js').hide(400);
            $('.header-nav-js').hide(400);
            isStickyHeaderNav = false;
            isStickyHeader = true;
            lastScrollTop = scrollTopValue;
            return;
        } else if(scrollTopValue <= headerTopOffset && isStickyHeader) {
            $('.main-js').css('padding-top', mainDivPaddingTop);
            $('.header-js').removeClass('fixed');
            $('.header-top-bar-js').show();
            if (window.innerWidth >= 1440) {
                $('.header-nav-js').show();
            }
            isStickyHeaderNav = true;
            isStickyHeader = false;
            lastScrollTop = scrollTopValue;
            return;
        }
        if (!isStickyHeader || window.innerWidth < 1440) {
            lastScrollTop = scrollTopValue;
            return;
        }
        if (scrollTopValue < lastScrollTop && scrollTopValue > headerTopOffset && !isStickyHeaderNav) {
            if (window.innerWidth >= 1440) {
                $('.header-nav-js').show(400);
                isStickyHeaderNav = true;
            }
        } else if(scrollTopValue > lastScrollTop && scrollTopValue > headerTopOffset && isStickyHeaderNav) {
            $('.header-nav-js').hide(400);
            isStickyHeaderNav = false;
        }
        lastScrollTop = scrollTopValue;
    },

    unstickHeader: function() {
        if ($(window).scrollTop() - $('.header-js').outerHeight() <= 0) {
            header.stickyHeader($('.header-js').height());
            $('.header-top-bar-js').show(400);
            if (window.innerWidth >= 1440) {
                $('.header-nav-js').show(400);
            }
        }
    },

    observeHeaderChanges: function() {
        const observer = new MutationObserver(function(mutationsList) {
            for(const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for(const node of mutation.addedNodes) {
                if (node.nodeType === 1) {
                    let isHeader;
                    if (node.classList && node.classList.contains('header-js')) {
                        isHeader = node;
                    } else if (node.querySelector) {
                        isHeader = node.querySelector('.header-js');
                    } else {
                        isHeader = null;
                    }
                    if (isHeader) {
                        header.headerMenuInit(true);
                        header.headerClientAreaInit();
                    }
                }
                }
            }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        
        return observer;
    },

    checkSVGSupport: function() {
		$('.header-js svg, .header-top-bar-js svg').each(function() {
			const $svg = $(this);
			const $hiddenParent = $svg.parents().filter(function() {
				return $(this).css('display') === 'none';
			});
			if ($hiddenParent.length > 0) {
				return;
			}
			const $useElement = $svg.find('use');
			if ($useElement.length > 0) {
				const width = $useElement.attr('width');
				const height = $useElement.attr('height');
				if (!width || !height || width === '0' || height === '0') {
					const href = $useElement.attr('xlink:href') || $useElement.attr('href');
					if (href) {
						$useElement.attr('xlink:href', '');
						$useElement.attr('href', '');
						
						setTimeout(() => {
							$useElement.attr('xlink:href', href);
							$useElement.attr('href', href);
						}, 100);
					}
				}
			}
		});
	},

    events: function() {
        //variable to clearTimeout in autocomplete function
        let timeOutAutocomplete = null;

        $(document).ready(function() {
            header.observeHeaderChanges();
            header.headerMenuInit(true);
            header.headerClientAreaInit();
            header.checkSVGSupport();
        });

        $(window).on('resize', function() {
            header.headerMenuInit(false);
            header.headerClientAreaInit();
            header.stickyHeaderResize();
        });

        if ($('body').find('.header-top-banner').index() >= 0) {
            topBannerFunctions.init();
        }

        $(window).on('scroll', function() {
            if (window.innerWidth > 767) {
                if (isStickyHeader) {
                    clearTimeout(stickyHeaderTimeoutId);
                }
                
                stickyHeaderTimeoutId = setTimeout(() => {
                    header.stickyHeader($('.header-js').height());
                }, 100);

                header.unstickHeader();
                if ($(window).scrollTop() - $('.header-js').outerHeight() <= 0) {
                    const showHeaderTimeout = setTimeout(function() {
                        header.unstickHeader();
                        clearTimeout(showHeaderTimeout);
                    }, 400);
                }
            }
        });

        $('body').on('click', '.quick-search-js', function(e) {
            e.preventDefault();
            window.quickSearch.search();
        });

        $('body').on('input', '.quick-search-form-js.autocomplete-form-js [name="search"]', function(e) {
            if(timeOutAutocomplete!=null){
                clearTimeout(timeOutAutocomplete);
                timeOutAutocomplete=null;
            }
            timeOutAutocomplete = setTimeout(function(){
               header.autocomplete(e);
            }, 300);
        });

        //variable to clearTimeout in change employee company function
        let timeOutChangeEmployeeInput = null;

        js.delegate(document.body, 'input', '.change-employee-company-search-js', e => {
            const phrase = e.target.value.replace(/[*]*/gi, '').toLowerCase();
        
            if(timeOutChangeEmployeeInput!=null){
                clearTimeout(timeOutChangeEmployeeInput);
                timeOutChangeEmployeeInput=null;
            }
            timeOutChangeEmployeeInput = setTimeout(function(){
                const employeeCompanyList = e.target.parentElement.parentElement.querySelectorAll('.change-employee-company-elements-js .change-employee-company-item-js');
                let orderValue = 0;
                for(let i = 0; i < employeeCompanyList.length; i++) {
                    const companyNameBox = employeeCompanyList[i].getElementsByClassName('change-employee-company-text-js');
                    const reg = new RegExp(phrase, 'gi');
                    const highlightedName = employeeCompanyList[i].dataset.name.replace(reg, function(str) {return '<strong style="color: #934346;">'+str+'</strong>'});
                    $(companyNameBox[0]).html(highlightedName);
                    employeeCompanyList[i].style.order = 'unset';
                    const companyName = employeeCompanyList[i].dataset.name.toLowerCase();
                    if (companyName.indexOf(phrase) !== -1 && phrase !== '') {
                        employeeCompanyList[i].style.order = orderValue;
                    } else {
                        orderValue -= 1;
                    }
                }
            }, 500);
        });
        
        $('body').on('click', '.change-employee-company-item-js', function(e) {
            e.preventDefault();
            const form = $(e.currentTarget).parents('.form-js');
            const id = $(this).children('input').val();
            const formInputToCopyTo = form.children("[name='id']");
            formInputToCopyTo.val(id);
            const data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            data.push({name: "__csrf", value: __CSRF});
            data.push({name: "__collection", value: 'customer.Carts'});
            $.post(null, data, function (d) {
                let activeInquiryId = -1;
                let lastCartId = -1;
                let cartCurrent = false;
                let cartCurrentId = -1;
                const carts = d.collection;
                for(let i=0; i<carts.length; i++){
                    if(carts[i].Inquiry){
                        activeInquiryId = carts[i].Id;
                    } else {
                        lastCartId = carts[i].Id;
                        if(carts[i].Current){
                            cartCurrent = true;
                            cartCurrentId = lastCartId;
                        }
                    }
                }
                if(cartCurrent){
                    lastCartId = cartCurrentId;
                }
                window.app.setCookie('lastCartId', lastCartId);
                window.app.setCookie('activeInquiryId', activeInquiryId);
                if (d.action.Redirect302) {
                    location.href = d.action.Redirect302;
                } else {
                    location.reload();
                }
            });
        });

        $('body').on('click', '.currency-dropdown-js [data-val]', function(e) {
			header.changeLanguageOrCurrency(e, 'currency');
		});

        $('body').on('click', '.lang-dropdown-js [data-val]', function(e) {
			header.changeLanguageOrCurrency(e, 'languageId');
		});

        $('body').on('click', '.header-autocomplete-closer-js', function(e) {
            $(e.currentTarget).addClass('hidden-js');
            $(e.currentTarget).parent().find('.header-search-input-js').val('');
            $(e.currentTarget).parent().find('.autocomplete-js').remove();
            $(e.currentTarget).parent().find('.loader-for-autocomplete-js').remove();
        });

        $('body').on('click', '.header-categories-js', (e) => {
            header.showSidebar('.header-categories-sidebar-js')
            const sidebar = $('.header-categories-sidebar-js');
            app.setLockFocus(sidebar, (f) => header.hideSidebar(f), $(e.target));
        });

        $('body').on('click', '.header-sidebar-closer-js', header.hideSidebar);

        $('body').on('click', '.header-sidebar-js', function(e) {
            if (e.currentTarget == e.target) {
                header.hideSidebar(e);
            }
        });

        $('body').on('click', '.header-categories-search-btn-js', header.searchCategory);

        $('body').on('click', '.header-categories-search-closer-js', function(e) {
            $(e.currentTarget).addClass('hidden-js');
            $(e.currentTarget).parent().find('[name=search-categories]').val('');
            $('.sliding-categories-js .header-categories-item-js').each(function() {
                $(this).removeClass('hidden-js');
            });
        });

        $('body').on('keyup', '.header-categories-search-js [type=search]', function(e){
            if ($(this).val() != '' && e.keyCode == 13) {
                header.searchCategory(e);
            }
        });

        $('body').on('click', '.header-cart-js', function(e) {
            header.showSidebar('.header-cart-sidebar-js');
            const cartSidebar =  $('.header-cart-sidebar-js');
            app.setLockFocus(cartSidebar, (f) => header.hideSidebar(f), $(e.target));
            if (!app.isCartListInitialized) {
            	app.setCartDropdownList();
            	app.isCartListInitialized = true;
            }
            app.activateFocusTrap('.header-cart-sidebar-js', e.currentTarget);
        });

        $('body').on('click', '.header-profile-js', function(e) {
            if ($(e.currentTarget).is('a')) {
                if (window.innerWidth < 1440) {
                    e.preventDefault();
                } else {
                    return;
                }
            }
            header.showSidebar('.header-profile-sidebar-js');
            const profileSidebar =  $('.header-profile-sidebar-js');
            app.setLockFocus(profileSidebar, (f) => header.hideSidebar(f), $(e.target));
        });

        $('body').on('click', '.header-menu-js', function(e) {
            header.showSidebar('.header-menu-sidebar-js');
            const menuSidebar =  $('.header-menu-sidebar-js');
            app.setLockFocus(menuSidebar, (f) => header.hideSidebar(f), $(e.target));
        });

        $('body').on('click', '.header-inquiry-js', function(e) {
            const activeInquiryId = app.getCookie('activeInquiryId');
            if(activeInquiryId != -1 || activeInquiryId != ''){
                const currTarget = $(e.currentTarget);
                $.post(null, { __csrf: __CSRF, __action: 'Cart/Change', id: activeInquiryId }, function () {
                    $.get(null, {__template: 'partials/common/header/inquiry-items-list.html'}, function (res) {
                        if (res.template) {
                            currTarget.parents('.header-inquiry-btn-js').find('.header-inquiry-sidebar-js').remove();
                            currTarget.after(res.template);
                            header.showSidebar('.header-inquiry-sidebar-js');
                            const inquirySidebar =  $('.header-inquiry-sidebar-js');
                            inquirySidebar.parents('.select-wcag-js').addClass('suspended-js');
                            app.setLockFocus(inquirySidebar, (f) => header.hideSidebar(f), $(e.target));
                        }
                    });
                });
            }
        });

        $('body').on('click', function(e) {
            if ($(e.target).parents('.dropdowns-js').index() != -1 || $(e.target).parents('.toggle-dropdown-js').index() != -1) {
                return;
            }
            $('.header-js, .header-top-bar-js').find('.dropdowns-js').each(function() {
                if (!$(this).hasClass('hidden-js')) {
                    $(this).addClass('hidden-js');
                }
            });
        });

        $('body').on('click', '.categories-menu-level-js', (e) => {
            header.hideSidebar(e);
            app.resetLockFocus((f) => header.hideSidebar(f));
        });

        $('body').on('click', '.header-menu-supervisor-js', function(e) {
            $(e.currentTarget).find('svg').toggle(500);
            $(e.currentTarget).parent().find('.header-menu-box-supervisor-js').toggle(500);
        });

        $('body').on('click', '.header-more-js', function(e) {
            $(e.currentTarget).parent().find('.header-more-dropdown-js').toggle(500);
        });
    }
}

function HeaderCategoriesNavigation(categoriesContainerSelector, slidingContentSelector, startGroupUrl, startGroupId, langId) {
    this.history = [];
    this.nameHistory = [];
    this.categoriesContainer = $(categoriesContainerSelector);
    this.slidingContentSelector = slidingContentSelector;
    this.firstLevelHtml = '';
    let thisRef = this;
    const firstLevelCategories = this.categoriesContainer.find(slidingContentSelector + ' .first-level-category-js');
    firstLevelCategories.each(function () {
        thisRef.firstLevelHtml += this.outerHTML;
    });
    this.backToTranslation = null;
    this.startGroupUrl = startGroupUrl || '';
    this.startGroupId = startGroupId || 0;
    this.langId = langId;
    this.animationTime = 500;
    this.filtersParam = 'ftrLst';

    this.reloadCategories = function (groupId, groupName, direction, callback) {
        const currentSlide = $(this.slidingContentSelector);

        const slideOverflowX = this.categoriesContainer.css('overflow-x');
        const slideOverflowY = this.categoriesContainer.css('overflow-y');

        const slidingContentClass = slidingContentSelector.slice(1, slidingContentSelector.length);

        this.categoriesContainer.css('overflow-x', 'hidden');
        this.categoriesContainer.css('overflow-y', 'hidden');

        if (groupId == 0) {
            const newSlide = $('<div class="header-categories__sliding ' + slidingContentClass + '" style="left:-100%">' + this.firstLevelHtml + '</div>').insertBefore(currentSlide);

            newSlide.find('.first-level-category-js').removeClass('hidden-js');

            thisRef = this;

            currentSlide.animate({
                left: '100%'
            }, thisRef.animationTime, function () {
                currentSlide.remove();
            });

            newSlide.animate({
                left: '0'
            }, thisRef.animationTime, function () {
                thisRef.categoriesContainer.css('overflow-x', slideOverflowX);
                thisRef.categoriesContainer.css('overflow-y', slideOverflowY);
            });

            this.history = [0];
            this.nameHistory = [__translations.ToCategoriesList];

            if (callback) {
                callback();
            }
        } else {
            const reqData = { __action: 'Get/Groups', groupId: groupId, languageId: this.langId, levels: 1 };
            let collectionRequested = false;

            if (this.history.length == 0) {
                reqData.__collection = 'page.Breadcrumbs';
                collectionRequested = true;
            }

            if (!this.backToTranslation) {
                reqData.__collection += '|translations.BackTo';
                reqData.__collection = reqData.__collection.replace(/undefined/g, '');
                collectionRequested = true;
            }

            thisRef = this;

            let requestUrl;
            if (collectionRequested) {
                requestUrl = thisRef.startGroupUrl;
            } else {
                requestUrl = $('base').attr('href');
            }

            $.get(requestUrl, reqData).then(function (res) {
                if (!thisRef.backToTranslation) {
                    thisRef.backToTranslation = res.collection['translations.BackTo'] || res.collection;
                }

                if (thisRef.history.length == 0) {
                    thisRef.history = [0];
                }

                let lastGroupId = thisRef.history[thisRef.history.length - 1];

                if (direction == 'next') {
                    thisRef.history.push(groupId);
                } else {
                    thisRef.history.pop();

                    if (thisRef.history.length == 1) {
                        lastGroupId = thisRef.history[0];
                    } else {
                        lastGroupId = thisRef.history[thisRef.history.length - 2];
                    }
                }

                if (thisRef.nameHistory.length == 0) {
                    thisRef.nameHistory = [__translations.ToCategoriesList];
                }

                let lastGroupName = thisRef.nameHistory[thisRef.nameHistory.length - 1];

                if (direction != 'next') {
                    thisRef.nameHistory.pop();

                    if (thisRef.nameHistory.length == 1) {
                        lastGroupName = thisRef.nameHistory[0];
                    } else {
                        lastGroupName = thisRef.nameHistory[thisRef.nameHistory.length - 2];
                    }
                }

                /* don't forget to change also html from sliding-navigation-partial.html !!! */
                let categoriesHTML = '<div class="header-categories__item back">' +  thisRef.backToTranslation + '<button class="header-categories__btn not-bold primary-color prev-level-js" data-id="' + lastGroupId + '" data-name="' + lastGroupName + '">' + lastGroupName + '</button></div>';

                if (direction == 'next') {
                    thisRef.nameHistory.push(groupName);
                }

                categoriesHTML += '<div class="header-categories__item title">' + groupName + '</div>';

                const currentCategories = res.action.Object;

                for (const catIndex in currentCategories) {
                    const cat = currentCategories[catIndex];
                    let hasNodesClass = '';
                    if (cat.HasNodes) {
                        hasNodesClass = 'has-nodes-js';
                    }

                    let isCurrentNode = false;
                    let currentNodeId = -1;

                    if (res.collection && res.collection['page.Breadcrumbs']) {
                        const lastBread = res.collection['page.Breadcrumbs'].length - 1;
                        currentNodeId = (res.collection['page.Breadcrumbs'][lastBread].Id).split(',')[1];

                        if (cat.Id == currentNodeId && !cat.HasNodes) {
                            isCurrentNode = true;
                        }
                    }

                    /* don't forget to change also html from sliding-navigation-partial.html !!! */
                    categoriesHTML += '<div class="header-categories__item header-categories-item-js ' + ' ' + hasNodesClass + ' " data-name="' + cat.Title + '">';

                    if (isCurrentNode) {
                        categoriesHTML += '<div class="header-categories__link">';
                    } else {
                        const catUrl = cat.Url || '';
                        const url = (catUrl.indexOf('//') === 0 || catUrl.indexOf('://') > -1) ? catUrl : ($('base').attr('href') || '') + catUrl;
                        categoriesHTML += '<a class="header-categories__link" href="' + url + '">';
                    }

                    categoriesHTML += cat.Title;

                    if (isCurrentNode) {
                        categoriesHTML += '</div>';
                    } else {
                        categoriesHTML += '</a>';
                    }

                    if (cat.HasNodes) {
                        categoriesHTML += '<button class="header-categories__arrow next-level-js" data-id="' + cat.Id + '" data-name="' + cat.Title + '">' + 
                                        '<svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#chevron-down-' + __iconStyle + '"></use></svg>' +
                                        '</button>';
                    }

                    categoriesHTML += '</div>';
                }

                if (direction == 'next') {
                    const newSlide = $('<div class="header-categories__sliding ' + slidingContentClass + '" style="left:100%">' + categoriesHTML + '</div>').insertAfter(currentSlide);

                    currentSlide.animate({
                        left: '-100%'
                    }, thisRef.animationTime, function () {
                        currentSlide.remove();
                    });

                    newSlide.animate({
                        left: '0'
                    }, thisRef.animationTime, function () {
                        thisRef.categoriesContainer.css('overflow-x', slideOverflowX);
                        thisRef.categoriesContainer.css('overflow-y', slideOverflowY);
                    });
                } else {
                    const newSlide = $('<div class="header-categories__sliding ' + slidingContentClass + '" style="left:-100%">' + categoriesHTML + '</div>').insertBefore(currentSlide);

                    currentSlide.animate({
                        left: '100%'
                    }, thisRef.animationTime, function () {
                        currentSlide.remove();
                    });

                    newSlide.animate({
                        left: '0'
                    }, thisRef.animationTime, function () {
                        thisRef.categoriesContainer.css('overflow-x', slideOverflowX);
                        thisRef.categoriesContainer.css('overflow-y', slideOverflowY);
                    });
                }

                if (callback) {
                    callback();
                }
            });
        }
    };
}

if ($('.header-category-column-js').length > 0) {
    const body = $('body');
    const categoriesContainer = $('.header-category-column-js');
    const langId = categoriesContainer.find('[data-lang]').data('lang');
    const startGroupUrl = categoriesContainer.find('[data-start-url]').data('start-url');
    const startGroupId = categoriesContainer.find('[data-start-id]').data('start-id') || 0;

    window.headerCategoriesNavigation = new HeaderCategoriesNavigation(categoriesContainer, '.sliding-categories-js', startGroupUrl, startGroupId, langId);

    body.on('click', '.header-category-column-js .next-level-js, .header-category-column-js .prev-level-js, .categories-first-level-js', function (e) {
        const categoryButton = $(this);
        const groupId = categoryButton.data('id');
        const groupName = categoryButton.data('name');
        let direction = 'prev';

        if (e.currentTarget.className.indexOf('next') >= 0) {
            direction = 'next';
        }

        if ($(e.currentTarget).hasClass('categories-first-level-js') || ($(e.currentTarget).hasClass('prev-level-js') && $(e.currentTarget).data('id') == 0)) {
            $(e.currentTarget).parents('.header-category-column-js').find('.categories-first-level-js').fadeOut(500);
            const timeoutId = setTimeout(function() {
                $(e.currentTarget).find('.header-category-column-js .header-categories-search-js').removeClass('wide');
                $(e.currentTarget).find('.header-category-column-js .categories-menu-level-js').removeClass('hidden-js');
                clearTimeout(timeoutId);
            }, 500);
        } else {
            $(e.currentTarget).parents('.header-category-column-js').find('.categories-first-level-js').fadeIn(500);
            $(e.currentTarget).parents('.header-category-column-js').find('.header-categories-search-js').addClass('wide');
            $(e.currentTarget).parents('.header-category-column-js').find('.categories-menu-level-js').addClass('hidden-js');
        }

        $(e.currentTarget).parents('.header-category-column-js').find('.header-categories-search-js [name=search-categories]').val('');
        $(e.currentTarget).parents('.header-category-column-js').find('.header-categories-search-closer-js').addClass('hidden-js');
        
        window.headerCategoriesNavigation.reloadCategories(groupId, groupName, direction);

        const timeOutLockFocus = setTimeout(function() {
            app.resetLockFocus((f) => header.hideSidebar(f));
            clearTimeout(timeOutLockFocus);
        }, 1000);
    });
}
class Timer {
    constructor() {
        this.observers = [];
        this.intervalId = null;
    }

    subscribe(observer) {
        this.observers.push(observer);
        if (this.observers.length === 1) {
            this.start();
        }
    }

    unsubscribe(observer) {
        this.observers = this.observers.filter(subscribedObserver => subscribedObserver !== observer);
        if (this.observers.length === 0) {
            this.stop();
        }
    }

    start() {
        if (this.intervalId) {
            return;
        }
        this.intervalId = setInterval(() => {
            const currentTime = new Date();
            this.notify(currentTime);
        }, 1000);
    }

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    notify(currentTime) {
        this.observers.forEach(observer => observer(currentTime));
    }
}
const timer = new Timer();
const topBannerFunctions = {
    topBanner: null,
    settings: null,
    carousel: null,
    timer : {
        element: null,
        date: null,
        translations : {
            days: null,
            hours: null,
            minutes: null,
            seconds: null
        },
    },
    
    getSettings: function() {
        const settingsString = this.topBanner.getAttribute('data-settings');
        
        if (settingsString) {
            try {
                return JSON.parse(settingsString);
            } catch (e) {
                console.error('Error parsing settings JSON:', e);
                return null;
            }
        }

        return null;
    },

    swiperInstance: null,
    initSwiper: function() {
        if (window.innerWidth < 769) {
            if (this.swiperInstance) {
                return;
            }
            
            this.swiperInstance = new Swiper(this.carousel, {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                navigation: false
            });
        }
        else {
            if (!this.swiperInstance) {
            return;
            }
            
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    },

    updateTimer: function(currentTime) {
        const timeLeft = this.timer.date - currentTime;

        if (timeLeft < 0) {
            this.timer.element.textContent = '0 ' + this.timer.translations.days + 
                                                ' 0 ' + this.timer.translations.hours + 
                                                ' 0 ' + this.timer.translations.minutes + 
                                                ' 0 ' + this.timer.translations.seconds;

            timer.unsubscribe(this.updateTimer.bind(this));
            return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        this.timer.element.textContent = days + ' ' + this.timer.translations.days + ' ' + 
                                            hours + ' ' + this.timer.translations.hours + ' ' + 
                                            minutes + ' ' + this.timer.translations.minutes + ' ' + 
                                            seconds + ' ' + this.timer.translations.seconds;

        if (this.timer.element.style.visibility === 'hidden' || this.timer.element.style.opacity === '0') {
            this.timer.element.style.visibility = 'visible';
            this.timer.element.style.opacity = '1';
        }
    },

    events: function() {
        if (this.carousel) {
            window.addEventListener('resize', this.initSwiper.bind(this));
        }
    },

    init: function() {
        this.topBanner = document.getElementById('topBanner');

        if (!this.topBanner) {
            return;
        }

        this.settings = this.getSettings();

        this.carousel = this.topBanner.querySelector('.header-top-banner__content--links');

        if (this.carousel) {
            this.initSwiper();
        }

        this.timer.element = this.topBanner.querySelector('.header-top-banner__countdown-timer');

        if (this.timer.element && this.settings?.timerDateTo) {
            this.timer.date = new Date(this.settings.timerDateTo);
            this.timer.translations.days = this.timer.element.getAttribute('data-translation-days');
            this.timer.translations.hours = this.timer.element.getAttribute('data-translation-hours');
            this.timer.translations.minutes = this.timer.element.getAttribute('data-translation-minutes');
            this.timer.translations.seconds = this.timer.element.getAttribute('data-translation-seconds');

            const hasTranslations = this.timer.translations.days && this.timer.translations.hours && this.timer.translations.minutes && this.timer.translations.seconds;

            if (hasTranslations) {
                const diff = this.timer.date - new Date();

                if (diff > 0) {
                    timer.subscribe(this.updateTimer.bind(this));
                } else {
                    this.timer.element.style.visibility = 'visible';
                    this.timer.element.style.opacity = '1';
                }
            }
        }

        this.events();
    },
};
`